import { ChannelGetDraft, ChannelGetDraftResponse } from "../proto/ChannelGetDraft_pb";
import { ChatGetDraft, ChatGetDraftResponse } from "../proto/ChatGetDraft_pb";
import { GroupGetDraft, GroupGetDraftResponse } from "../proto/GroupGetDraft_pb";
import store from "../store";
import { editRoom } from "../store/rooms/actions";
import BaseHandler from "./BaseHandler";
import { setDraftText } from "../store/draft/actions";

export default class HandleRoomGetDraftResponse extends BaseHandler<ChatGetDraftResponse | GroupGetDraftResponse | ChannelGetDraftResponse, ChatGetDraft | GroupGetDraft | ChannelGetDraft> {
  handle() {
    const roomGetDraftRequest = this.request?.toObject();
    const roomGetDraftResponse = this.response.toObject();
    if (roomGetDraftRequest !== undefined) {
      // store.dispatch(
      //   editRoom({
      //     roomId: roomGetDraftRequest.roomId,
      //     room: {
      //       draft: roomGetDraftResponse.draft,
      //     },
      //   })
      // );
      const roomId = roomGetDraftRequest.roomId;
      store.dispatch(setDraftText({ draft: roomGetDraftResponse.draft, roomId }));
    }
  }
}
